// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-GTzD","questions":"styles_questions__b7AH0","footer":"styles_footer__Sy6Sd"};